import type { User } from 'firebase/auth';

/** Public route for signed-in users pending email verification. */
export const VERIFY_EMAIL_PENDING_PATH = '/auth/verify-email';

const SUPERADMIN_ROLES = new Set(['superadmin', 'system_superadmin']);

/**
 * True when a signed-in user must complete email verification before free registered-user routes.
 * System superadmins are exempt (admin operations only; not used for ordinary free signup).
 */
export function requiresEmailVerification(
  user: User | null | undefined,
  systemRole?: string | null,
  role?: string | null,
): boolean {
  if (!user) return false;
  if (user.emailVerified) return false;

  const trimmedSystem = systemRole?.trim() ?? '';
  const trimmedRole = role?.trim() ?? '';
  if (SUPERADMIN_ROLES.has(trimmedSystem) || SUPERADMIN_ROLES.has(trimmedRole)) {
    return false;
  }

  return true;
}

/** Build redirect to the verification-pending surface, preserving a safe return path. */
export function buildVerifyEmailPendingHref(nextPath: string): string {
  return `${VERIFY_EMAIL_PENDING_PATH}?next=${encodeURIComponent(nextPath)}`;
}
